import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form'
import { Dropdown } from 'semantic-ui-react';

import './TextArrayField.css';

const TextArrayDropdown = ({ input, name, suggestions, t }) => {
    const selected = (input.value || []).filter(v => !!v);
    const suggestion_list = (suggestions || []).filter(v => typeof v === 'string' && v !== '');
    const options = [...new Set([...suggestion_list, ...selected])].map(text => ({
        key: text,
        text: text,
        value: text,
    }));

    const onChange = (e, data) => {
        input.onChange(data.value);
    };

    return <Dropdown
        name={name}
        options={options}
        value={input.value || []}
        onChange={onChange}
        allowAdditions={true}
        additionLabel={t('common.add') + ' ' }
        noResultsMessage=""
        search
        clearable
        fluid
        multiple
        selection
    />;
};

const TextArrayField = ({ name, suggestions = [] }) => {
    const { t } = useTranslation();

    return (
        <div className="TextArrayField">
            <Field
                multiple
                name={name}
                component={TextArrayDropdown}
                suggestions={suggestions}
                t={t}
                className="form-control"
            />
        </div>
    );
}

export default TextArrayField;
